@if ({}; as STATE) {
  <section class="advertiser-group-creation-dialog">
    <advertiser-group-creation-form [advertiser]="advertiser()" />
  </section>
}
